import {
  LocationIcon,
  MailIcon,
  MobileIcon,
  PhoneIcon,
  PostIcon,
  SiteIcon,
} from "./Icons";
import { useContent } from "../../i18n";
import "./style.scss";

export const Contacts = () => {
  const { contact } = useContent();

  return (
    <div id="contact" className="contact-wrapper">
      <h2>{contact.title}</h2>
      <div className="container contact-sec">
        <div className="contact-right-sec">
          <h3>{contact.company}</h3>
          <p>
            <span>
              <LocationIcon />
            </span>
            {contact.address}
          </p>
          <p>
            <span>
              <MailIcon />
            </span>
            <bdi dir="ltr">info@medhubeg.com</bdi>
          </p>
          <p>
            <span>
              <MailIcon />
            </span>
            <bdi dir="ltr">info@zrs-hubtech.com</bdi>
          </p>
          <p>
            <span>
              <PhoneIcon />
            </span>
            <bdi dir="ltr">+20 2612 4800</bdi>
          </p>
          <p>
            <span>
              <PostIcon />
            </span>
            <bdi dir="ltr">+20 2612 4801</bdi>
          </p>
          <p>
            <span>
              <MobileIcon />
            </span>
            <bdi dir="ltr">+20 122 343 3310</bdi>
          </p>
          <p>
            <span>
              <SiteIcon />
            </span>
            <bdi dir="ltr">www.zrs-hubtech.com</bdi>
          </p>
        </div>
        <div className="contact-left-sec">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d110528.20354396719!2d31.36276064860701!3d30.036675373403032!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1458238eaa1e03a1%3A0x845defe0f2f2c127!2sAdmnistrative%20Building%20No.%205%2C%20Zizinia%20Resort%2C%20Fifith%20Settlement%20New%20Cairo%2C%20Cairo%20Government!5e0!3m2!1sen!2seg!4v1736439127935!5m2!1sen!2seg"
            width="100%"
            height="100%"
            title="map"
            style={{ border: 0 }}
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </div>
  );
};
